import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useRouteRedirect = (
  currentLocation: string,
  navigateTo: string
) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === currentLocation) {
      navigate(navigateTo);
    }
  }, [location]);
};
